import {
  type UseSuspenseQueryResult,
  useSuspenseQuery,
} from '@tanstack/react-query';

import api from '@/axios';
import { GET_LOT_SIZINGS_KEY } from '@/keys';
import type { LotSizing } from '@/types/core/lot-sizing/lot-sizing';
import type { Paginated } from '@/types/core/paginated';
import type { DataTableQueryVariables } from '@/types/data-table';

export const getLotSizings = async ({
  page,
  perPage,
  sort,
  filters,
}: DataTableQueryVariables<LotSizing>): Promise<Paginated<LotSizing>> => {
  const response = await api.get<Paginated<LotSizing>>('/lot-sizings', {
    params: {
      page,
      perPage,
      ...(sort?.length ? { sort: JSON.stringify(sort) } : {}),
      ...(filters?.length ? { filters: JSON.stringify(filters) } : {}),
    },
  });
  return response.data;
};

export const useGetLotSizings = ({
  page,
  perPage,
  sort,
  filters,
}: DataTableQueryVariables<LotSizing>): UseSuspenseQueryResult<
  Paginated<LotSizing>,
  Error
> =>
  useSuspenseQuery({
    queryKey: [...GET_LOT_SIZINGS_KEY, page, perPage, sort, filters],
    queryFn: () => getLotSizings({ page, perPage, sort, filters }),
  });
